<template>
  <div>
    <div>
      <div v-if="editable">
        <v-select
          v-if="select"
          dense
          :label="title"
          v-model="info"
          :items="items"
          @input="$emit('update:info', info)"
        />
        <v-text-field
          v-else
          dense
          :rules="phone ? [rules.phoneLength] : []"
          :label="title"
          v-model="info"
          @input="$emit('update:info', info)"
        />
      </div>
      <v-row v-else>
        <v-col :cols="cols ? cols[0] : 6" class="py-0">
          <v-card-text class="pb-0 pt-1">
            {{ title }}
          </v-card-text>
        </v-col>
        <v-col :cols="cols ? cols[1] : 6" class="py-0">
          <v-card-text
            class="text-subtitle-1 font-weight-medium text-capitalize text-truncate text-right pb-0 pt-1"
          >
            {{ info && info.text ? info.text : info }}
          </v-card-text>
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import { MobileView } from '@/mixins';
import GroupDetailData from '@/mixins/GroupDetailData';

export default {
  data() {
    return {
      rules: {
        phoneLength: (v) => /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/.test(v)
          || 'Please enter a valid 10 digit phone number',
      },
    };
  },
  props: {
    info: String,
    title: String,
    type: String,
    cols: Array,
    select: Boolean,
    items: Array,
    phone: Boolean,
  },
  mixins: [MobileView, GroupDetailData],
};
</script>
